import React, {Component} from 'react';
import {authService} from "../auth";
import "./styles/EndorsementPopUp.min.css";
import ProfileVisibility from "./ProfileVisibility";

class OutSideWNEmailConfirmPopUp extends Component {

    constructor(props) {
        super(props);
        this.multiselectRef = React.createRef();
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),

        }

    }

    triggerProfileVisibilityClose = ()=>{

    }

    triggeredProfileVisibilityCloseOnSuccess = ()=>{

    }

    render() {
        const {error,openProfileVisibilityModal} = this.state;
        return <>
            <div className="modal fade dgpopup confirmpop" id="outsideWNEmailerConfirmPopUp" tabIndex="-1" role="dialog"
                 aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        {/* <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">Confirmation Message</h5>                            
                        </div> */}
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span
                                aria-hidden="true">&times;</span></button>
                        <div className="confirm-popup-modal-body">
                            {this.props.messageEmailSent}
                        </div>

                    </div>
                </div>
            </div>
            {
                openProfileVisibilityModal &&
                <ProfileVisibility entityId={this.props.entityId}
                                   triggerProfileVisibilityClose={this.triggerProfileVisibilityClose}
                                   visibleToProfileChecked={true}
                                   triggeredProfileVisibilityCloseOnSuccess={this.triggeredProfileVisibilityCloseOnSuccess}/>
            }
        </>


    }
}



export default OutSideWNEmailConfirmPopUp;


